import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import firebaseConfig from '../config/firebase.config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Functions
export const functions = getFunctions(app);

// Connect to emulators in development mode
if (import.meta.env.DEV) {
  console.log('🔧 Connecting to Firebase Emulators...');
  
  // Connect Firestore to emulator (port: 8081)
  connectFirestoreEmulator(db, 'localhost', 8081);
  
  // Connect Auth to emulator (default port: 9099)
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  
  // Connect Functions to emulator (port: 5001)
  connectFunctionsEmulator(functions, 'localhost', 5001);
  
  console.log('✅ Connected to Firebase Emulators');
}

export default app;
